import FavoriteStar from './FavoriteStar';

export default FavoriteStar;
